import React from 'react'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'

import serviceExample from './images/service_example.png'

export const HomePage: React.FC = () => {
	const navigate = useNavigate()

	return (
		<Container>
			<Title>쉽고 빠른 마케팅 툴</Title>
			<SubTitle>
				단 5분, 쉽게 만드는 챌린지 콘텐츠로 <br />
				인지도&구매전환율 UP!
			</SubTitle>
			<ActionButton onClick={() => navigate('/challenge/hotdeal-registration')}>
				첫 달, 무료로 시작하기
			</ActionButton>
			<ServiceExampleImage src={serviceExample} />
		</Container>
	)
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	background: linear-gradient(to bottom, #fff3ca 0%, #fff3ca 60%, #fff 60%, #fff 100%);
`

const Title = styled.div`
	color: #121212;
	text-align: center;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 150%;
	margin-top: 78px;
`

const SubTitle = styled.div`
	color: #121212;
	text-align: center;
	font-size: 30px;
	font-style: normal;
	font-weight: 700;
	line-height: 150%;
	margin-top: 8px;
`

const ActionButton = styled.button`
	border: none;
	padding: 10px 24px;
	border-radius: 10px;
	background: #ffcf19;
	color: #121212;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	text-align: center;
	margin-top: 28px;
`

const ServiceExampleImage = styled.img`
	width: 1126px;
	margin-top: 36px;
	margin-bottom: 92px;
`
